import { DistrictNcesDetail, JobPosting } from "@nimble/candidate-api/types";
import { Building2 } from "lucide-react";

import { getDistrictLocation } from "@/app/(discover)/jobs/[stateName]/districts/[districtId]/lib/district-view-models";
import ExternalApplicationLinkButton from "@/components/shared/buttons/external-application-link-button/external-application-link-button";
import { ShareButton } from "@/components/shared/jobs/direction-and-share-buttons";
import JobViewActionsView from "@/components/shared/jobs/job-view-actions/job-view-actions.view";
import { jobActionButtonKeys } from "@/lib/constants/jobs.constants";
import { districtJobDetailsTestIds } from "@/lib/data-test-ids/districts.data-test-ids";

interface DistrictJobDetailsPanelProps {
  jobPosting: JobPosting;
  district: DistrictNcesDetail;
  jobHref: string;
  interestMessage: string;
}

export default function DistrictJobDetailsPanel({
  jobPosting,
  district,
  jobHref,
  interestMessage,
}: DistrictJobDetailsPanelProps) {
  const location = getDistrictLocation(district);

  return (
    <div className="flex flex-col gap-4">
      <section
        className="flex flex-col gap-2"
        data-testid={districtJobDetailsTestIds.DISTRICT_JOB_PANEL}
      >
        <p className="text-xs font-semibold uppercase tracking-wide text-ink-subtle">
          District-wide role
        </p>
        <div className="flex items-center gap-2">
          <Building2
            className="w-5 h-5 shrink-0 text-ink-subtle"
            aria-hidden="true"
          />
          <p
            className="font-bold text-base text-foreground"
            data-testid={districtJobDetailsTestIds.DISTRICT_JOB_PANEL_NAME}
          >
            {district.name}
          </p>
        </div>
        {location && (
          <p
            className="text-sm text-ink-subtle"
            data-testid={districtJobDetailsTestIds.DISTRICT_JOB_PANEL_LOCATION}
          >
            {location}
          </p>
        )}
        <p className="text-sm text-ink-emphasis">
          Posted for the district, not one school. Where you would work is
          decided when you are hired.
        </p>
      </section>
      <JobViewActionsView
        className="h-full py-4"
        interestMessage={interestMessage}
        titleId={`job-view-actions-title-${jobPosting.uuid}`}
        buttons={[
          <ExternalApplicationLinkButton
            key={jobActionButtonKeys.EXTERNAL_APPLICATION}
            jobUrl={jobPosting.job_url}
            jobId={jobPosting.uuid}
          />,
        ]}
      />
      <div className="border-t border-border pt-4">
        <ShareButton
          shareUrl={jobHref}
          entityId={jobPosting.uuid}
          label="Share job"
        />
      </div>
    </div>
  );
}
